'use client';

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { PriceInquiryForm } from "@/components/ui/PriceInquiryForm";

interface PriceInquiryModalProps {
  isOpen: boolean;
  onClose: () => void;
  productId: string;
  productName: string;
}

export function PriceInquiryModal({
  isOpen,
  onClose,
  productId,
  productName,
}: PriceInquiryModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[700px] p-0 overflow-hidden border-none" aria-describedby="price-inquiry-description">
        <DialogHeader className="bg-white px-6 py-4 border-b border-gray-100 flex flex-row items-center justify-between">
          <DialogTitle className="text-left text-lg font-bold text-gray-800">
            Fiyat Teklifi Al
          </DialogTitle>
          <DialogDescription id="price-inquiry-description" className="sr-only">
            Fiyat Sorgulama Formu
          </DialogDescription>
        </DialogHeader>
        <div className="bg-[#F3F2EB]">
          <PriceInquiryForm
            productId={productId}
            productName={productName}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
} 